import React from 'react';
import { DialogTitle, IconButton, Typography } from '@material-ui/core';
import { Theme, WithStyles, createStyles, withStyles } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';

const styles = (theme: Theme) =>
  createStyles({
    root: {
      margin: 0,
      padding: theme.spacing(2),
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
  });

export interface DialogTitleProps extends WithStyles<typeof styles> {
  children: React.ReactNode;
  onClose: () => void;
  color?: string;
  titleColor?: string;
}

const ClosableDialogTitle = withStyles(styles)((props: DialogTitleProps) => {
  const { children, classes, onClose, color, titleColor } = props;
  return (
    <DialogTitle disableTypography className={classes.root} style={{ backgroundColor: color || undefined }}>
      <Typography variant="h6" style={{ color: titleColor || undefined }}>
        {children}
      </Typography>
      {onClose ? (
        <IconButton
          aria-label="Close"
          className={classes.closeButton}
          style={{ color: titleColor || undefined }}
          onClick={onClose}
        >
          <CloseIcon style={{ color: titleColor || undefined }} />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
});

export default ClosableDialogTitle;
